<template>
  <v-content class="bg-content">
          <v-container grid-list-xl style="padding: 10px; top: -40px">
        <v-card dark class="card-animate-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="75"
            height="75"
            elevation="3"
            dense
            dark
          >
            <v-toolbar-title>
              <v-avatar size="40">
                                <img src="@/assets/InterfaceIcon2.png">
                        </v-avatar>
              Concierge
            </v-toolbar-title>

            <v-spacer></v-spacer>
   
          </v-app-bar>
        </v-card>
        </v-container>
        <v-container grid-list-xl>
          <v-flex xs4 sm4 md4 lg12>
                  <CogneetivAI />
                  <br />
          <br />
          <br />
          </v-flex>
        </v-container>
        <v-container grid-list-xl style="padding: 10px; top: -40px">
        <v-card dark class="card-animate-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="75"
            height="75"
            elevation="3"
            dense
            dark
          >
            <v-toolbar-title>
              <v-avatar size="40">
                                <img src="@/assets/MilestoneIcon.png">
                        </v-avatar>
              Marketing
            </v-toolbar-title>

            <v-spacer></v-spacer>
   
          </v-app-bar>
        </v-card>
        </v-container>
          <v-flex xs4 sm4 md4 lg12>
            <BrowserSearchComponentVoice />
            <!-- <AIController /> -->
          </v-flex>
          <v-divider />
          <br />
          <!-- <v-flex sm6 xs6 md4 lg12>
            <BrowserSearchResearch />
          </v-flex> -->


    <v-overlay :value="overlay" opacity="0.99" z-index="9">
      <!-- <v-btn class="mx-2 close-btn" fab dark small color="#ccc" @click="overlay = false">X</v-btn> -->
      <v-card v-scroll.self="onScroll">
        <CommandAssistantInterface v-if="type == 'commands'" />
        <Calendar v-if="type == 'calendar'" />
        <Email v-if="type == 'email'" />    
        <VideoPlayer v-if="type == 'mix'" />
        <VideoPlayerTwo v-if="type == 'night'" />
        <VideoPlayerThree v-if="type == 'tech'" />
        <VideoPlayerFour v-if="type == 'smooth'" />
        <VideoPlayerFive v-if="type == 'cyber'" />  
        <VideoPlayerSix v-if="type == 'rap'" />
        <VideoPlayerSeven v-if="type == 'chill'" />
        <VideoPlayerEight v-if="type == 'hits'" />
        <VideoPlayerNine v-if="type == 'jazz'" />
        <VideoChat v-if="type == 'video'" />
        <ScreenShare v-if="type == 'share'" />
        <!-- <Timer v-if="type == 'timer'" /> -->
      </v-card>
    </v-overlay>
  </v-content>
</template>

<script>
// import AIController from '../components/AIController.vue';
// import Visualizer from '../components/Visualizer.vue';
// import VoiceVolume from '@/components/VoiceVolume.vue';
import CogneetivAI from '../components/CogneetivAI.vue';
import BrowserSearchComponentVoice from '../components/BrowserSearchComponentVoice.vue';
import CommandAssistantInterface from '../components/CommandAssistantInterface.vue';
import Calendar from '../components/Calendar.vue';
import VideoPlayer from '../components/VideoPlayer.vue';
import VideoPlayerTwo from '../components/VideoPlayerTwo.vue';
import VideoPlayerThree from '../components/VideoPlayerThree.vue';
import VideoPlayerFour from '../components/VideoPlayerFour.vue';
import VideoPlayerFive from '../components/VideoPlayerFive.vue';
import VideoPlayerSix from '../components/VideoPlayerSix.vue';
import VideoPlayerSeven from '../components/VideoPlayerSeven.vue';
import VideoPlayerEight from '../components/VideoPlayerEight.vue';
import VideoPlayerNine from '../components/VideoPlayerNine.vue';
import Email from '../components/Email.vue';
// import CogneetivCodex from '../components/CogneetivCodex.vue';
// import BrowserSearchResearch from './../components/BrowserSearchResearch.vue';
// import Animation15 from '../components/Animation15.vue';
import startAudio from '@/assets/audio/Hud.wav';
// import CogneetivCodexVue from '../components/CogneetivCodexClient.vue';
// import Timer from '../components/Timer.vue';

export default {
  name: 'Dashboard',
  data: () => ({
    texts: null,
    dashboard: {},
    overlay: false,
    type: '',
  }),
  components: {
    // AIController,
    // Visualizer,
    // VoiceVolume,
    // Timer,
    // BrowserSearchResearch,
    CogneetivAI,
    // CogneetivCodex,
    BrowserSearchComponentVoice,
    CommandAssistantInterface,
    // Animation15,
    Calendar,
    Email,
    VideoPlayer,
    VideoPlayerTwo,
    VideoPlayerThree,
    VideoPlayerFour,
    VideoPlayerFive,
    VideoPlayerSix,
    VideoPlayerSeven,
    VideoPlayerEight,
    VideoPlayerNine,
  },
  computed: {},
  methods: {
    getDashboard: async function() {
      const rawResponse = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}analytics/all`
      );
      const content = await rawResponse.json();
      this.dashboard = content.response;
      console.log(content);
      new Audio(startAudio).play();
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

      speech.onend = function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 4000);
     };
    },
  },
  mounted() {
    this.getDashboard();
    Event.$on('showCard', (data) => {
      console.log(data);
      if (data.msg.indexOf('calendar') != -1) {
        this.type = 'calendar';
      }
      this.overlay = true;
    });
    Event.$on('showEmail', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('email') != -1) {
        this.type = 'email';
      }
      this.overlay = true;
    });
    Event.$on('showCommands', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('commands') != -1) {
        this.type = 'commands';
      }
      this.overlay = true;
    });
    Event.$on('showDialog', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('dialog') != -1) {
        this.type = 'dialog';
      }
      this.overlay = true;
    });
    Event.$on('showVideo', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('video') != -1) {
        this.type = 'video';
      }
      this.overlay = true;
    });
    Event.$on('showShare', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('share') != -1) {
        this.type = 'share';
      }
      this.overlay = true;
    });
    Event.$on('playMix', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('mix') != -1) {
        this.type = 'mix';
      }
      this.overlay = true;
    });
    Event.$on('playNight', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('night') != -1) {
        this.type = 'night';
      }
      this.overlay = true;
    });
    Event.$on('playTech', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('tech') != -1) {
        this.type = 'tech';
      }
      this.overlay = true;
    });
    Event.$on('playChill', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('chill') != -1) {
        this.type = 'chill';
      }
      this.overlay = true;
    });
    Event.$on('playSmooth', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('smooth') != -1) {
        this.type = 'smooth';
      }
      this.overlay = true;
    });
    Event.$on('playCyber', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('cyber') != -1) {
        this.type = 'cyber';
      }
      this.overlay = true;
    });
    Event.$on('playRap', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('rap') != -1) {
        this.type = 'rap';
      }
      this.overlay = true;
    });
    Event.$on('playHits', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('hits') != -1) {
        this.type = 'hits';
      }
      this.overlay = true;
    });
    Event.$on('playUrban', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('urban') != -1) {
        this.type = 'urban';
      }
      this.overlay = true;
    });
    Event.$on('playJazz', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('jazz') != -1) {
        this.type = 'jazz';
      }
      this.overlay = true;
    });
    Event.$on('startTimer', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('timer') != -1) {
        this.type = 'timer';
      }
      this.overlay = true;
    });
    Event.$on('closeCard', (data) => {
      if (this.$route.path !== '/interface') {
        return;
      }
      console.log(data);
      this.overlay = false;
    });
  },
};
</script>

<style scoped src="../components/css/Style.css">
@import '../components/css/Style.css';
@import url('https://fonts.googleapis.com/css2?family=Coda:wght@400;800&display=swap');


.space {
  height: 20px;
}

.theme-icons {
  background: #304057;
  color: #fff;
  size: 100px;
}

.theme-icons:hover {
  background: #304057;
  color: #fff;
}

.theme-bg-player {
  width: 800px;
}

.textWelcome {
  color: #78b59c;
  font-size: 48px;
  font-family: 'lato';
  font-weight: thin;
  position: relative;

  left: 0%;
  right: 0px;
}

.animate {
  top: 100px;
}
.chart-content {
  background: rgba(12, 22, 27, 0.4);
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 0px;
  top: -60px;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}


@media only screen and (max-width: 600px) {
.chart-content {
  background: rgba(12, 22, 27, 0.4);
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 0px;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}

}

.animation {
  position: relative;
  top: -30px;
  font-size: 15px;
  min-height: 0px;
  left: 0%;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}

.animation2 {
  position: absolute;
  top: -198px;
  font-size: 15px;
  min-height: 0px;
  left: 0%;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}

.animation3 {
  position: absolute;
  top: 440px;
  font-size: 15px;
  min-height: 0px;
  left: -32%;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}

.mic2 {
  width: 40px;
  position: relative;
  top: 10px;
  border-radius: 50%;
  opacity: 1;
}
.animation4 {
  position: absolute;
  top: 440px;
  font-size: 15px;
  min-height: 0px;
  left: 32%;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}

.animation5 {
  position: relative;
  top: -1050px;
  font-size: 15px;
  min-height: 0px;
  left: -10 %;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}
.uicontainer {
    position: relative;
    margin-block: -30px;
    background: #78b59c;

}

.chatBoxAI {
    background-color: #5a80bf;
    filter: progid: DXImageTransform.Microsoft.gradient(gradientType=1, startColorstr='#48a981', endColorstr='#2f9269');
    background-image: url(//img.alicdn.com/tps/TB1d.u8MXXXXXXuXFXXXXXXXXXX-1900-790.jpg);
    background-size: 100%;
    background-image: -webkit-gradient(linear, 0 0, 100% 100%, color-stop(0, #48a981), color-stop(100%, #2f9269));
    background-image: -webkit-linear-gradient(135deg, #48a981, #2f9269);
    background-image: -moz-linear-gradient(45deg, #48a981, #2f9269);
    background-image: -ms-linear-gradient(45deg, #48a981 0, #2f9269 100%);
    background-image: -o-linear-gradient(45deg, #48a981, #2f9269);
    background-image: linear-gradient(135deg, #48a981, #2f9269);
    padding-block: 50px;
    margin-left: 5%;
    position: sticky;
    padding: 50px 50px;
    border-radius: 20px;
    text-align: left;
    width: 90%;
}

.chatBox {
    padding-block: 50px;
    margin-left: 5%;
    position: sticky;
    padding: 50px 50px;
    border-radius: 20px;
    text-align: left;
    width: 90%;
	background: linear-gradient(-45deg,  #192b44, #0f1724, #000417);
	-webkit-animation: gradient 25s ease infinite;
	-animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}

p:first-letter {
    text-transform: capitalize;
}
.reply {
    text-align: right;
    background: linear-gradient(45deg,  #192b44, #0f1724, #000417);
    color: #48a981;
    padding: 25px 50px;
    border-radius: 20px;
}

p:last-child {
    margin-bottom: 100px;
}
iframe {
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
    width: 48%;
    height: 450px;
    margin-block: 10px;
    margin-left: 10px;
    margin-right: 10px;
    padding-block: 20px;
    border-radius: 20px;
    /* opacity: 0.9; */
}
ul {
    text-align: left;
}
.texts {;
    color: white;
    padding: 25px 50px;
    font-size: 25px;
    align-items: left;
    background: #000;
    padding: 25px 50px;
    border-radius: 20px;
}

.theme-bg-card {
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: rgba(48, 64, 87, 0.6);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.6);
}

.theme-bg-card:hover {
  text-decoration: none;
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
    inset 0 0 10px rgba(90, 128, 191, 0.8), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
}

.theme-bg-card-5 {
  background: rgba(46, 47, 53, 0.669);
  outline-color: #5a80bf;
  color: #fff;
  border: 5px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-warning {
  background: rgba(255, 255, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-warning:hover {
  background: rgba(255, 255, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(0, 255, 0, 0.1),
    0 2px 0 #000;
  color: #efe;
  outline: none;
}

.theme-bg-card-negative {
  background: rgba(255, 0, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-negative:hover {
  background: rgba(255, 0, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #ff0000;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.2), inset 0 0 5px rgba(255, 0, 0, 0.1),
    0 2px 0 #000;
  color: #efe;
  outline: none;
}

.theme-bg-card-lg {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-lg:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1000ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 7px rgba(0, 255, 0, 0.2), inset 0 0 7px rgba(0, 255, 0, 0.1),
    0 2px 0 #000;
  outline: none;
}

@keyframes glow {
  0% {
    border-color: #393;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2),
      inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78b59c;
    box-shadow: 0 0 8px rgba(0, 255, 0, 0.8),
      inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}

.space1 {
  height: 35px;
}

.space2 {
  height: 1px;
}

.space3 {
  height: 1px;
}

.space4 {
  height: 1px;
}

.tabbar {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  & > li {
    margin: 0 11px;
    & > svg {
      width: 14px;
      height: 14px;
      display: block;
      fill: #2f3545;
      transition: opacity 0.3s ease;
    }
  }
  &.open {
    & > li {
      & > svg {
        opacity: 0.5;
      }
    }
  }
}

.Center & dribbble body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  background: #171c28;
  display: flex;
  justify-content: center;
  align-items: center;
  .dribbble {
    position: fixed;
    display: block;
    right: 20px;
    bottom: 20px;
    img {
      display: block;
      height: 28px;
    }
  }
}

.text-color-2 {
  color: #42da91 !important;
}
 .bg-content-3 {
    background: #131f25e1;
    padding: 0px;
    min-height: 87vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 100%;
    }
    

.ui-animate {
  animation-name: slidetop;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 10s;
  transition: opacity 10s Elastic.easeIn;
}
.ui-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 10s;
  transition: opacity 10s Elastic.easeOut;
}

/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: 0px;
    opacity: 0;
  }
  100% {
    left: 10px;
    top: 0px;
    opacity: 1;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
    opacity: 0;
  }
  100% {
    left: 0px;
    top: 0px;
    opacity: 1;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}

.user-ui {
  background: rgba(48, 64, 87, 1);
  opacity: 1;
  color: #fff;
  padding: 20px;
}

.theme-bg-2 {
  background: rgba(48, 64, 87, 0.3);
  color: #fff;
}
.menu-icon {
  background: rgba(48, 64, 87, 0.3);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.menu-icon:hover {
  background: rgba(48, 64, 87, 0.5);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.icons {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  color: #42da91 !important;
}
.icons:hover {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffffff !important;
}
.detail-card {
  width: 800px;
  height: 400px;
  background: #304057;
  opacity: 0.75;
  position: absolute;
}

.chart {
  color: #fff;
  background: #304057;
  background-size: 400% 400%;
  margin-left: 0px;
  padding: 25px;
  width: 404px;
  cursor: pointer;
  top: -60px;
  min-height: 10vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}

.db-content {
  background: linear-gradient(-45deg, #28456d, #0f1724, #000417);
  background-size: 400% 400%;
  min-height: 100vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}

.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
.three-dot {
  margin-top: 10px;
  float: right;
  color: #fff;
}
.product-animate {
  animation-name: slideleft;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.product-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.info-animate {
  animation-name: slideleft;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.info-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.product {
  width: 400px;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: 0px;
  }
  100% {
    left: 10px;
    top: 0px;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}

.slideExpandUp {
  animation-name: slideExpandUp;
  -webkit-animation-name: slideExpandUp;

  animation-duration: 2.6s;
  -webkit-animation-duration: 2.6s;

  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;

  visibility: visible !important;
}

@keyframes slideExpandUp {
  0% {
    transform: translateY(100%) scaleX(0.94);
  }
  30% {
    transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    transform: translateY(2%) scaleX(0.96);
  }
  50% {
    transform: translateY(0%) scaleX(1);
  }
}

@-webkit-keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(100%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(2%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

@media only screen and (max-width: 600px) {
  .product {
    width: 90%;
  }
  .card-margin {
    margin-top: 40px;
  }
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
  .db-content {
    min-height: 100vh;
  }
  .menu-icon-2 {
    margin-left: 20px;
    color: #42da91 !important;
    margin-top: 20px;
  }
  .mb-margin {
    text-align: center;
  }
  .detail-card {
    width: 350px;
    height: 100%;
  }
  .callouts {
    padding: 100px;
    border: outline;
    background: #304057;
    opacity: 0.9;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
    outline-color: #5a80bf;
    outline-style: solid;
    animation: glow 1800ms ease-out infinite alternate;
    border-color: #5a80bf;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
      inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
    outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

  .user-speach {
    position: absolute;
    top: -350px;
    font-size: 16px;
    width: 80%;
    left: 200px;
    right: 0px;
    border-radius: 15px;
    color: #fff;
    background: linear-gradient(
      -45deg,
      #0f1724,
      #151f2f,
      #19253a,
      #304057,
      #0f1724
    );
    background-size: 400% 400%;

    -webkit-animation: gradient 15s ease infinite;
    -animation: gradient 15s ease infinite;
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  }

  .button {
    text-decoration: none;
    font-family: Arial, Helvetica, sans-serif;
  }

  .avatar-name {
    position: relative;
    top: 10px;
    font-weight: 600;
    color: rgb(48, 47, 47);
    margin-left: 8px;
    margin-right: 5px;
  }

  .about {
    padding: 30px;
    background: rgba(48, 64, 87, 0.1);
    color: #111;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .callouts:hover {
    padding: 30px;
    border: outline;
    background: #304057;
    opacity: 1;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
  }
}
</style>
